import { Component, Input, Renderer2 } from '@angular/core';
import { IconHover } from '../../../../../shared/enum/common-enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../../shared/services/common.service';
import { AgGridI } from '../../../../../shared/common-components/ag-grid/ag-grid.model';
import { AgGridDataModel } from './clone-product.model';
import { ProductOpeningService } from '../../product-opening.service';

@Component({
  selector: 'app-clone-product',
  templateUrl: './clone-product.component.html',
  styleUrls: ['./clone-product.component.scss']
})
export class CloneProductComponent extends CommonService {
  currentHoverEffect = IconHover.Pink;
  constructor(public activeModal: NgbActiveModal, public renderer: Renderer2, private productOpeningService: ProductOpeningService,) { super(renderer); }
  agGridDataModel: AgGridI;
  gridApi: any;
  inputValue = '';
  originalGridData: any[] = [];
  @Input() data: any;
  isLoading: boolean = false;
  ngOnInit(): void {
    this.agGridDataModel = AgGridDataModel;
  }

  onGridReady(event) {
    this.gridApi = event;
    this.GetUnMappedProductsByBranchId()
  }

  GetUnMappedProductsByBranchId() {
    this.isLoading = true;
    this.productOpeningService.GetUnMappedProductsByBranchId().subscribe({
      next: (res) => {
        if (res?.isSuccess) {
          this.isLoading = false;
          this.originalGridData = res.response || [];
          this.gridApi?.api?.setRowData(this.originalGridData);
        }
      }, error: (err) => {
        this.isLoading = false;
      }
    })
  }

  selectRow(index: number) {
    this.gridApi.api.forEachNode((node) => node.setSelected(false));
    const rowNode = this.gridApi?.api?.getDisplayedRowAtIndex(index);
    if (rowNode) {
      this.gridApi.api.ensureIndexVisible(index);
      rowNode.setSelected(true);
    }
  }

  onSearchChange(event) {
    if (this.inputValue?.trim().length >= 0 && event !== "") {
      const searchLower = this.inputValue?.trim()?.toLowerCase();
      const filteredData = this.originalGridData?.filter(x => x?.name?.toLowerCase()?.includes(searchLower)) || [];
      this.gridApi?.api?.setRowData(filteredData);
    } else {
      this.gridApi?.api?.setRowData(this.originalGridData);
    }
  }

  cloneProduct() {
    const data = this.gridApi?.api?.getSelectedRows();
    const productIds = data?.map(item => +item.id) || [];
    const requestData = { productIds };
    this.productOpeningService.cloneProduct(requestData).subscribe({
      next: (res) => {
        if (res?.isSuccess) {
          this.activeModal?.close(res);
          this.cleanupCheckboxes();
        }
      }, error: (err) => {
      }
    })
  }
  cleanupCheckboxes() {
    this.gridApi?.api?.forEachNode((node) => {
      if (node?.data?.active) {
        node.data.active = false;
        this.gridApi?.api?.refreshCells({ rowNodes: [node] });
      }
    });
  }
  closeModel() {
    this.activeModal?.close();
    this.cleanupCheckboxes();
  }
}
